import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { themes } from "segments/segments-service";
import { StyledTagComponent } from "./tag-component.scss";
import DefaultProps from "./default-props";
class TagComponent extends PureComponent {
    getTagStyle() {
        const { color } = this.props;
        return themes[color];
    }
    render() {
        const { text } = this.props;
        const tagStyle = this.getTagStyle();
        return /*#__PURE__*/ _jsx(StyledTagComponent, {
            className: "tag-component",
            style: tagStyle,
            children: text
        });
    }
}
export { TagComponent as default };
TagComponent.defaultProps = DefaultProps;
